import firebase, { auth, RecaptchaVerifier } from '../config/firebase';
import { regexValidation } from "utils/regexValidation";

let pending = null;
let verifiedUser = null;
let contact = null;

export const clearPhoneLogin = () => {
  pending = null;
  verifiedUser = null;
  contact = null;
};

export const hasPhoneLogin = number => contact === String(number) && !!pending;

export const sendPhoneOtp = async (number, container) => {
  const value = String(number).trim();
  if (!regexValidation.PHONE.test(value)) {
    throw new Error('Please enter a valid 10-digit Indian mobile number.');
  }
  const verifier = new RecaptchaVerifier(container, { size: 'invisible' }, auth.app);
  try {
    await auth.setPersistence(firebase.auth.Auth.Persistence.NONE);
    const result = await auth.signInWithPhoneNumber(`+91${value}`, verifier);
    pending = result;
    verifiedUser = null;
    contact = value;
  } finally {
    verifier.clear();
  }
};

export const confirmPhoneOtp = async (number, code) => {
  if (!hasPhoneLogin(number)) {
    throw new Error('Your OTP session has ended. Please request a new code.');
  }
  // Retain the verified user so a backend network failure can be retried.
  if (!verifiedUser) {
    const result = await pending.confirm(code);
    verifiedUser = result.user;
  }
  return verifiedUser.getIdToken();
};

export const phoneAuthError = error => {
  const messages = {
    'auth/invalid-verification-code': 'Incorrect OTP. Please enter the six-digit code from your SMS.',
    'auth/code-expired': 'Your OTP has expired. Please request a new code.',
    'auth/session-expired': 'Your OTP has expired. Please request a new code.',
    'auth/invalid-phone-number': 'Please enter a valid 10-digit Indian mobile number.',
    'auth/too-many-requests': 'Too many attempts. Please wait before trying again.',
    'auth/quota-exceeded': 'SMS is temporarily unavailable. Please try again later.',
    'auth/captcha-check-failed': 'Verification failed. Please try again.',
    'auth/network-request-failed': 'Please check your internet connection and try again.',
    'auth/operation-not-allowed': 'Phone login is not enabled. Please contact support.',
    'auth/unauthorized-domain': 'Phone login is not configured for this website. Please contact support.',
  };
  return messages[error.code] || error.data?.message || error.message || 'Unable to log in. Please try again.';
};
